import Gator from 'gator';

const DOC = document;

Gator(DOC.documentElement).on('click', '.hamburger-icon', function() {
    DOC.body.classList.toggle('-menuopen');
    this.blur();
});
